import UploadNewsForm from "../../UploadNewsForm";
import { createReading } from "../../../api";
import { Container } from "@mui/material";
import { useNavigate } from "react-router-dom";

export default function CreateNewReading() {
  const navigate = useNavigate();
  const customSubmitFunction = async (title, description, image) => {
    try {
      const result = await createReading(title, description, image);
      if (result) {
        navigate("/readings/all");
      }
    } catch (error) {}
  };
  return (
    <>
      <Container>
        <UploadNewsForm
          customsubmit={customSubmitFunction}
          breadCrumbLink={"Readings"}
          breadCrumbText={"Create New"}
          goBackLink={"/readings/all"}
        />
      </Container>
    </>
  );
}
